// extracted by mini-css-extract-plugin
export default {"container":"TrailingBadge-module__container__Uys4U0v","label":"TrailingBadge-module__label__eY0zXb9","title":"TrailingBadge-module__title__iiMuLEN"};